// Slider zeigen, sobald irgendeine zeitbezogene Ebene aktiv ist (Vessel-Routen oder Wetter)
export function useTimeSliderVisibility({
  vesselReportedRoutes,
  switchReported,
  switchPlan,
  switchFleetPlan,
  switchVoyagePlannerActive,
  hasDraftRoute,
  hasWeatherTimeSlider,
}) {
  const hasVesselTimeSlider =
    vesselReportedRoutes !== null &&
    (switchReported ||
      switchPlan ||
      switchFleetPlan ||
      (switchVoyagePlannerActive && hasDraftRoute))

  return hasVesselTimeSlider || hasWeatherTimeSlider
}
